import { ProxyConfiguration as SchabuProxyConfiguration } from "@schabu/web.sdk/models";
import { IEnvironment } from "./interfaces/iEnvironment";

export const ENVIRONMENT: IEnvironment = {
	schabu: {
		proxy: new SchabuProxyConfiguration("https://api.schabu.com", true, true)
	}
}